import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
//import { FIND_USER } from "../queries";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React, { useState, useEffect } from "react";
// Routes
//import routes from "routes";
//import Information from "./Information";
// Images
import bgImage from "assets/images/profiili.png";
//import { ALL_MUNICIPALITIES } from "queries";
//import { useLazyQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Profile = ({ selectedKunta, setSelectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  //console.log(setSelectedKunta);
  const shareUrl = "https://kunta.live/municipality/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  //const [user, setUser] = useState(null);
  /*const [user, setUser] = useState({
    __typename: "",
    name: "",
    email: "",
    address: "",
    postnumber: "",
    postoffice: "",
    phone: "",
    activated: true,
    type: "",
    datetime: "",
    acceptedtermsofuse: null,
    gender: null,
    born: null,
    municipality: null,
    country: null,
    locked: false,
    code: "",
    id: "",
  });
  */
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [postnumber, setPostnumber] = useState("");
  const [postoffice, setPostoffice] = useState("");
  const [datetime, setDatetime] = useState("");
  const [gender, setGender] = useState("");
  const [born, setBorn] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [role, setRole] = useState("");
  const [secondarymunicipality, setSecondarymunicipality] = useState("");
  const [secondarypostnumber, setSecondarypostnumber] = useState("");
  const [secondaryaddress, setSecondaryaddress] = useState("");
  const [secondaryrole, setSecondaryrole] = useState("");
  const [country, setCountry] = useState("");
  useEffect(() => {
    const namee = localStorage.getItem("name");
    const emaili = localStorage.getItem("email");
    const phonee = localStorage.getItem("phone");
    const addresss = localStorage.getItem("address");
    const postnumberr = localStorage.getItem("postnumber");
    const postofficee = localStorage.getItem("postoffice");
    const datetimee = localStorage.getItem("datetime");
    const genderr = localStorage.getItem("gender");
    const bornn = localStorage.getItem("born");
    const municipalityy = localStorage.getItem("municipality");
    const secondarymunicipalityy = localStorage.getItem("secondarymunicipality");
    const rolee = localStorage.getItem("role");
    const countryy = localStorage.getItem("country");
    const secondaryrolee = localStorage.getItem("secondaryrole");
    const secondaryaddresss = localStorage.getItem("secondaryaddress");
    const secondarypostnumberr = localStorage.getItem("secondarypostnumber");
    if (name !== undefined) {
      //setEmail(useri.email);
      setName(namee);
      setEmail(emaili);
      setPhone(phonee);
      setAddress(addresss);
      setPostnumber(postnumberr);
      setPostoffice(postofficee);
      setDatetime(datetimee);
      setGender(genderr);
      setBorn(bornn);
      setMunicipality(municipalityy);
      setCountry(countryy);
      setRole(rolee);
      setSecondarymunicipality(secondarymunicipalityy);
      setSecondaryaddress(secondaryaddresss);
      setSecondarypostnumber(secondarypostnumberr);
      setSecondaryrole(secondaryrolee);
    }
  }, []);
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="black"
              textAlign="left"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h1>{t("user.header")}</h1>
              <br />
              <tr>
                <td>{t("user.name")}:</td>
                <td>{name}</td>
              </tr>
              <tr>
                <td>{t("user.email")}:</td>
                <td>{email}</td>
              </tr>
              <tr>
                <td>{t("user.phone")}:</td>
                <td>{phone}</td>
              </tr>
              <tr>
                <td>{t("user.address")}:</td>
                <td>{address}</td>
              </tr>
              <tr>
                <td>{t("user.postnumber")}:</td>
                <td>{postnumber}</td>
              </tr>
              <tr>
                <td>{t("user.postoffice")}:</td>
                <td>{postoffice}</td>
              </tr>
              <tr>
                <td>{t("user.registerdate")}:</td>
                <td>{datetime}</td>
              </tr>
              <tr>
                <td>{t("user.gender")}:</td>
                <td>{gender}</td>
              </tr>
              <tr>
                <td>{t("user.born")}:</td>
                <td>{born}</td>
              </tr>
              <tr>
                <td>{t("user.municipality")}:</td>
                <td>{municipality}</td>
              </tr>
              <tr>
                <td>{t("user.role")}:</td>
                <td>{role}</td>
              </tr>
              <tr>
                <td>{t("user.secondarymunicipality")}:</td>
                <td>{secondarymunicipality}</td>
              </tr>
              <tr>
                <td>{t("user.secondaryaddress")}:</td>
                <td>{secondaryaddress}</td>
              </tr>
              <tr>
                <td>{t("user.secondarypostnumber")}:</td>
                <td>{secondarypostnumber}</td>
              </tr>
              <tr>
                <td>{t("user.secondaryrole")}:</td>
                <td>{secondaryrole}</td>
              </tr>
              <tr>
                <td>{t("user.country")}:</td>
                <td>{country}</td>
              </tr>
              <br />
              <br />
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Profile;
